import { render } from "./SogCardContent.vue?vue&type=template&id=eb4d4d82&scoped=true"
const script = {}

import "./SogCardContent.vue?vue&type=style&index=0&id=eb4d4d82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4d4d82"]])

export default __exports__